const loadCoursesToShow = async () => {
  let courses = [];
  let startTime = new Date();

  try {
    courses = JSON.parse(sessionStorage.getItem("availableCourses"));
    console.log(`Available Courses: ${courses.length}`);
  } catch (error) {
    console.log("Not data found in session for courses");
    courses = [];
  }

  if (courses.length === 0) {
    try {
      let response = await fetch("data/courses.json");
      courses = await response.json();
      courses.map((data) => console.log(data));
      sessionStorage.setItem("availableCourses", JSON.stringify(courses));
    } catch (error) {
      console.error("Error fetching courses:", error);
      courses = [];
    }
  }
  let totalTime = new Date().getTime() - startTime.getTime();
  console.log(
    `Time taken to finish fetch: ${Math.floor(totalTime / 1000 / 60)} minutes ${Math.floor(totalTime / 1000) % 60} seconds`,
  );

  return courses;
};

const fetchCourses = async (availableCourses, fetchType) => {
  let courseList = [];
  let startTime = new Date();
  let cacheName = fetchType === "eager" ? "prefetchCourses" : "courseList";

  try {
    courseList = JSON.parse(sessionStorage.getItem(cacheName));
    console.log(`Total Courses: ${courseList.length}`);
  } catch (error) {
    console.log("Not data found in session for courses");
    courseList = [];
  }
  if (courseList.length === 0) {
    let coursesToProcess = availableCourses.filter(
      (course) => course.fetchType === fetchType,
    );

    courseList = await fetchRequiredCourses(coursesToProcess);
    let totalTime = new Date().getTime() - startTime.getTime();
    console.log(
      `Time taken to finish fetch: ${Math.floor(totalTime / 1000 / 60)} minutes ${Math.floor(totalTime / 1000) % 60} seconds`,
    );
    if (courseList.length > 22) {
      sessionStorage.setItem(cacheName, JSON.stringify(courseList));
    }
  }

  return courseList;
};

const fetchRequiredCourses = async (coursesToFetch) => {
  const courseList = [];

  try {
    const coursePromises = coursesToFetch.map(async (course) => {
      try {
        let response;
        if (course.courseType === "catalog") {
          response = await fetchAllCoursesInCatalog(
            course.courseId,
            course.catalogName,
          );
        } else if (course.courseType === "course") {
          if (course.parserType === "scrom") {
            response = await fetchScormCourseById(
              course.catalogName,
              course.courseId,
              "",
            );
          } else {
            response = await fetchCourseDetailsById(
              course.catalogName,
              course.courseId,
              "",
            );
          }
        }

        if (response) {
          const data = Array.isArray(response) ? response : [response];
          courseList.push(...data);
        }
      } catch (error) {
        console.error(
          `Error fetching course with ID: ${course.courseId}, Catalog Name: ${course.catalogName}`,
          error,
        );
      }
    });

    await Promise.all(coursePromises);
    return courseList;
  } catch (error) {
    console.error("Error fetching required courses:", error);
    return [];
  }
};

const fetchAllCoursesInCatalog = async (catalogId, catalogName) => {
  const courseList = [];
  const parser = new DOMParser();
  const catalogQueue = [{ cId: catalogId, cName: catalogName, cData: null }];
  const startTime = new Date();

  while (catalogQueue.length > 0) {
    const currentCatalog = catalogQueue.shift();
    try {
      const result = await fetchCatalogData(currentCatalog.cId);

      if (result) {
        currentCatalog.cData = result;
        const xmlDoc = parser.parseFromString(
          currentCatalog.cData.response,
          "text/xml",
        );
        const courseNodes = Array.from(xmlDoc.getElementsByTagName("Node"));

        const nestedCatalogs = courseNodes.filter(
          (course) => course.getAttribute("hasChildren") === "true",
        );
        const courses = courseNodes.filter(
          (course) => course.getAttribute("hasChildren") !== "true",
        );

        catalogQueue.push(
          ...nestedCatalogs.map((course) => ({
            cId: course.childNodes.item(0).getAttribute("value"),
            cName: course.getAttribute("text"),
            cData: null,
          })),
        );

        const courseDetailsPromises = courses.map((course) =>
          parseCatalogString(currentCatalog.cName, course.getAttribute("text")),
        );

        const courseDetails = await Promise.all(courseDetailsPromises);
        courseDetails.forEach((details) => {
          if (details) {
            courseList.push(...details);
          }
        });
      }
    } catch (error) {
      console.error(
        `Error processing catalog ID: ${currentCatalog.cId}, Name: ${currentCatalog.cName}`,
        error,
      );
    }
  }

  const totalTime = new Date().getTime() - startTime.getTime();
  console.log(
    `Time taken to fetch courses under Catalog: ${catalogName}: ${Math.floor(totalTime / 1000 / 60)} minutes ${Math.floor(totalTime / 1000) % 60} seconds`,
  );
  return courseList;
};

const fetchCatalogData = async (catalogId) => {
  if (isNaN(+catalogId)) {
    console.log(`Invalid Catalog Number: ${catalogId}`);
    return null;
  }

  try {
    const response = await fetch(
      `https://catalys.portal.nttdataservices.com/course/catalogue.php?id=${catalogId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/xml" },
        body: `<ChildrenRequest version="1"><Attribute name="code" value="${catalogId}"/></ChildrenRequest>`,
      },
    );

    if (!response.ok) {
      throw new Error("Error fetching data");
    }

    const xmlText = await response.text();
    return { cId: catalogId, response: xmlText };
  } catch (error) {
    console.log("Error:", error);
    return null;
  }
};

const parseCatalogString = async (catalogName, data) => {
  const parser = new DOMParser();
  const webContent = parser.parseFromString(data, "text/html");
  const table = webContent.querySelector(".tablea");
  const courseList = [];

  if (!table) return courseList;

  const coursePromises = Array.from(table.rows)
    .slice(1)
    .map((row) => {
      const url = row.cells[1].querySelector("a").href;
      return fetchCourseDetailsById(
        catalogName,
        new URL(url).searchParams.get("id"),
        row.cells[2].textContent,
      );
    });

  const coursesDetailResults = await Promise.all(coursePromises);
  coursesDetailResults.forEach((courseDetails) => {
    if (courseDetails) {
      courseList.push(courseDetails);
    }
  });

  return courseList;
};

const fetchCourseDetailsById = async (catalogName, courseId, duration) => {
  const courseURL = `https://catalys.portal.nttdataservices.com/course/view.php?id=${courseId}`;

  try {
    const response = await fetch(courseURL);
    if (!response.ok) {
      throw new Error(
        `Failed to fetch course details for Course ID: ${courseId}`,
      );
    }

    const content = await response.text();
    const parser = new DOMParser();
    const webContent = parser.parseFromString(content, "text/html");

    const title =
      webContent.querySelector(".header-heading")?.textContent?.trim() || "";

    const overviewNode =
      webContent.querySelector(".ml-1") ||
      webContent.querySelector(".container-fluid > :nth-child(1)");
    const overview =
      overviewNode?.textContent?.replace(/\n/g, "").trim().substring(0, 200) ||
      "";

    const statusNode =
      webContent.querySelector(".block-content-area:nth-child(1)") ||
      webContent
        .querySelector(".block-content-area:nth-child(2)")
        ?.childNodes?.item(1) ||
      webContent.getElementById("id_submitbutton");
    const status =
      statusNode?.firstChild?.textContent?.split(":")[1]?.trim() ||
      statusNode?.value ||
      "";

    return {
      key: `${catalogName}_${courseId}`,
      catalogName,
      title,
      description: overview,
      duration,
      status,
      link: courseURL,
    };
  } catch (error) {
    console.error(
      `Error fetching course details for Course ID: ${courseId}`,
      error,
    );
    return null;
  }
};

const fetchScormCourseById = async (catalogName, courseId, duration) => {
  const scormURL = `https://catalys.portal.nttdataservices.com/mod/scorm/view.php?id=${courseId}`;

  try {
    const response = await fetch(scormURL);
    if (!response.ok) {
      throw new Error(
        `Failed to fetch SCORM course data for Course ID: ${courseId}`,
      );
    }

    const content = await response.text();
    const parser = new DOMParser();
    const webContent = parser.parseFromString(content, "text/html");

    const title =
      webContent.querySelector(".header-heading")?.textContent?.trim() || "";

    const columnScorm = webContent.querySelector(".columnscorm");
    const overviewNode = columnScorm?.children[2] || columnScorm?.children[1];
    const overview =
      overviewNode?.textContent?.replace(/\n/g, "").trim().substring(0, 200) ||
      `Learn more about ${title} by visiting the course.`;

    if (!duration) {
      const durationNode = columnScorm?.children[0];
      duration =
        durationNode?.textContent?.replace(/\n/g, "").trim().split(":")[1] ||
        "";
    }

    const statusSteps = Array.from(
      webContent.querySelectorAll(".automatic-completion-conditions > *"),
    );
    const completedSteps = statusSteps.filter((step) =>
      step.classList.contains("alert-success"),
    ).length;
    const totalSteps = statusSteps.length;
    const status =
      completedSteps === totalSteps
        ? "Completed"
        : completedSteps === 0
          ? "Enroll Me"
          : "In Progress";

    return {
      key: `${catalogName}_${courseId}`,
      catalogName,
      title,
      description: overview,
      duration,
      status,
      link: scormURL,
    };
  } catch (error) {
    console.error(`Error fetching SCORM course with ID: ${courseId}`, error);
    return null;
  }
};

export { loadCoursesToShow, fetchCourses };
